import { createAction } from "@reduxjs/toolkit"

export const getHotelListAction = createAction("getHotelListAction")
export const getHotelCategoryListAction = createAction("getHotelCategoryListAction")
export const createHotelCategoryAction = createAction("createHotelCategoryAction")
export const getHotelCategoryDetailAction = createAction("getHotelCategoryDetailAction")
export const editHotelCategoryAction = createAction("editHotelCategoryAction")
export const deleteHotelCategoryAction = createAction("deleteHotelCategoryAction")
export const getDynamicFieldsAction = createAction("getDynamicFieldsAction")
export const addDynamicFieldsAction = createAction("addDynamicFieldsAction")
export const revertAllHotel = createAction("revertAllHotel")
export const getHotelSubCategoryAction = createAction("getHotelSubCategoryAction")
export const createHotelSubCategoryAction = createAction("createHotelSubCategoryAction")
export const getHotelNestedCategoryAction = createAction("getHotelNestedCategoryAction")
export const createHotelNestedCategoryAction = createAction("createHotelNestedCategoryAction")
export const getHotelNestedSubCategoryAction = createAction("getHotelNestedSubCategoryAction")
export const createHotelNestedSubCategoryAction = createAction("createHotelNestedSubCategoryAction")
export const editHotelNestedSubCategoryAction = createAction("editHotelNestedSubCategoryAction")
export const deleteHotelNestedSubCategoryAction = createAction("deleteHotelNestedSubCategoryAction")
export const getHotelServiceItemAction = createAction("getHotelServiceItemAction")
export const deleteHotelServiceItemAction = createAction("deleteHotelServiceItemAction")
export const createCategoryItemsAction = createAction("createCategoryItemsAction")
export const editCategoryItemsAction = createAction("editCategoryItemsAction")
export const uploadImageAction = createAction("uploadImageAction")
export const getCategoryItemsAction = createAction("getCategoryItemsAction")
export const changeCategoryOrderAction = createAction("changeCategoryOrderAction")
